import React from 'react';
import PropTypes from 'prop-types'
import Transition from 'react-transition-group/Transition';
import Link from '../components/IntlLink'
import NakedLink from 'gatsby-link'
import { injectIntl } from 'react-intl';
import darkBurger from "../images/menu.svg"
import whiteBurger from "../images/menu_white.svg"
import whiteLogo from "../images/logo_white.svg"
import darkLogo from "../images/logo_black.svg"
import close from "../images/round-close.svg"
import humps from "humps"

class Menu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hoverColor: null,
      isMenuVisible: false,
      isFakeFadeActive: false
    };
  }

  handleSelect(to) {
    const realTo = this.props.intl.locale === 'it' ? `/it${to}` : to;

    if (realTo === this.context.currentPathname) {
      this.setState({ isMenuVisible: false })
    } else {
      this.setState({ isFakeFadeActive: true })
    }
  }

  handleClose() {
    this.setState({ isMenuVisible: false })
  }

  handleToggleMenu() {
    this.setState({ isMenuVisible: !this.state.isMenuVisible })
  }

  handleHover(color, e) {
    e.stopPropagation();

    this.setState({
      hoverColor: color
    });
  }

  renderMenu() {
    const menuStyles = {
      entering: {
        display: 'block',
        pointerEvents: 'none'
      },
      exiting: {
        pointerEvents: 'none'
      },
      exited: {
        display: 'none'
      },
    };

    const flashStyles = {
      entering: {
        animation: '.5s ease-in-out menu__flashAppear'
      },
      entered:  {
        display: 'none',
      },
      exiting: {
        animation: '.5s ease-in-out menu__flashAppear'
      },
      exited:  {
        display: 'none',
      },
    };

    const contentStyles = {
      entering: {
        animation: '.01s linear menu__contentAppear 0.25s 1 normal both'
      },
      entered:  {
        opacity: 1
      },
      exiting: {
        animation: '.01s linear menu__contentAppear 0.25s 1 reverse both'
      },
      exited:  {
        opacity: 0
      },
    };

    const contentBgStyle = this.state.hoverColor ?
      { backgroundColor: this.state.hoverColor } :
      {};

    const allData = this.props.data;

    return (
      <Transition
        in={this.state.isMenuVisible}
        timeout={500}
      >
        {
          (state) => (
            <div className="menu" style={menuStyles[state]}>
              <div className="menu__flash" style={flashStyles[state]}/>
              <div
                className="menu__content"
                onMouseOver={this.handleHover.bind(this, null)}
                style={Object.assign(contentStyles[state], contentBgStyle)}
              >
                <div className="menu__content__inner">
                  {
                    ['catalog', 'interchangeability', 'philosophy', 'about', 'news', 'contact'].map(page => {
                      const data = allData[humps.camelize(`menu_${page}`)];
                      const to = data.slug ? `/p/${data.slug}` : `/`;

                      return (
                        <Link
                          key={page}
                          to={to}
                          className="menu__link"
                          onMouseOver={this.handleHover.bind(this, data.themeColor.hex)}
                          onClick={this.handleSelect.bind(this, to)}
                        >
                          {data.menuTitle}
                        </Link>
                      );
                    })
                  }
                </div>
                <div className="menu__locale-switch">
                  <NakedLink to="/">English</NakedLink> | <NakedLink to="/it">Italiano</NakedLink>
                </div>
              </div>
              <Transition
                in={this.state.isFakeFadeActive}
                timeout={200}
              >
                {
                  (state) => (
                    <div
                      className="menu__fake-transition"
                      style={
                        ({
                          entering: {
                            animation: '200ms linear menu__fakeTransAppear 0s 1 normal both'
                          },
                          entered: {
                            top: '0'
                          }
                        })[state]
                      }
                    />
                  )
                }
              </Transition>
            </div>
          )
        }
      </Transition>
    );
  }

  renderMenuAction() {
    if (this.state.isMenuVisible) {
      return close
    } else if (this.props.hasWhiteLogo) {
      return whiteBurger
    } else {
      return darkBurger
    }
  }

  render() {
    return (
      <div>
        <div className="header" style={this.props.style}>
          <div className="header__logo">
            <Link to="/" >
              {
                this.props.hasWhiteLogo || this.state.isMenuVisible ?
                  <img src={whiteLogo}/> :
                  <img src={darkLogo}/>
              }
            </Link>
            <div className="header__hamburger" onClick={() => this.handleToggleMenu()}>
              <img src={ this.renderMenuAction() }/>
            </div>
          </div>
        </div>
        {this.renderMenu()}
      </div>
    );
  }
}

Menu.contextTypes = {
  currentPathname: PropTypes.string
};

export default injectIntl(Menu);



// WEBPACK FOOTER //
// ./src/components/Menu.js